import { type ElementType } from "react";

import {
  AwsLogo,
  AzureLogo,
  GcpLogo,
  K8sLogo,
  TencentCloudLogo,
  ProviderSelector as UIProviderSelector,
  formatProviderFullName,
  type Provider,
} from "@stacklet/ui";

import { useConfig } from "app/contexts";
import { useStickyState } from "app/hooks";

const PROVIDER_LOGOS: Partial<Record<Provider, ElementType>> = {
  aws: AwsLogo,
  azure: AzureLogo,
  gcp: GcpLogo,
  tencentcloud: TencentCloudLogo,
  k8s: K8sLogo,
};

interface Props {
  onChange: (provider: Provider) => void;
}

export function ProviderSelector({ onChange }: Props) {
  const [selectedProvider, setSelectedProvider] = useStickyState<Provider>(
    "aws",
    "provider",
  );

  const config = useConfig();
  const providers = (config?.cloud_providers ?? []) as Provider[];

  function handleChange(provider: Provider) {
    setSelectedProvider(provider);
    onChange(provider);
  }

  const providerItems = providers.map((p) => ({
    logo: PROVIDER_LOGOS[p] ?? AwsLogo,
    key: p,
  }));

  return (
    <UIProviderSelector
      formatProvider={formatProviderFullName}
      onChange={handleChange}
      providers={providerItems}
      selected={selectedProvider}
      icons
    />
  );
}
